import React from "react"
import { render } from "react-dom"
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom"

import moment from "moment"
import "moment/locale/zh-cn"
import "antd/dist/antd.css"
import "./index.css"

import store from "./store"
import { Provider } from "react-redux"

import App from "./views/App/App"
import Home from "./views/Home/Home"
import Home2 from "./views/Home2/Home2"

moment.locale("zh-cn")

import { initLoginAction } from "./store/actionCreators"

//读取本地的登录信息至redux
let storage = window.localStorage
if (storage.hasLogin === "1") {
  store.dispatch(initLoginAction(storage.token))
}

render(
  <Provider store={store}>
    <BrowserRouter>
      <Switch>
        <Route path="/login" component={App} />
        <Route path="/home" component={Home} />
        <Route path="/home2" component={Home2} />
        <Redirect path="/" to="/login" />
      </Switch>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
)
